// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__1eiNo","first":"Grid_first__2x-Ly","projection":"Grid_projection__dBRTJ","color":"Grid_color__9jIRd"};